import { CompanyMemberRole } from "@components/table/members/members-column/role-column/company-member-role";
import { useCompanyId } from "@context-providers/company-id-provider";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** Member data to display and edit the workspace role for */
  member: FaroCoreApiTypes.CompanyMemberDetails;
}

/** Dropdown to display and change the workspace role of a member or team */
export function WorkspaceRoleDropdown({ member }: Props): JSX.Element {
  const companyId = useCompanyId();
  const { role, identity } = member;

  return (
    <CompanyMemberRole
      companyId={companyId}
      memberIdentityRole={{ role, identity }}
      variant="standard"
      location="workspace-role-dropdown"
      menuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        PaperProps: {
          sx: { width: "270px" },
        },
      }}
    />
  );
}
